export { HttpPaginationModule } from './http-pagination.module';
export { HttpPaginationComponent } from './http-pagination.component';

export { HttpPaginationService, PaginationOptions } from './http-pagination.service';
